<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the default component for rendering the Duty activity title                                      -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <div class="d-flex DutyActivityTitle_Default" v-if="hasTrueChildren">
    <div class="d-flex flex-grow-1 align-center" style="height: 30px">
      <h3>
        <b>Kurs {{ courseTitle }}</b>
      </h3>
      <v-btn v-if="!isNaN(dutyActivity.blockcode) && showAllTracksBtn" class="caption" text rounded x-small @click.prevent.stop="onSelect"
        >{{ $t(selectAllLine ? 'fd.showCompleteTrack' : 'fd.showDutyActivity') }}
      </v-btn>
    </div>
    <duty-activity-type-icon v-if="showActivityTypeIcon" :dutyActivity="dutyActivity"></duty-activity-type-icon>
    <duty-activity-json v-if="showTitleJsonHint" :dutyActivity="dutyActivity"></duty-activity-json>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import DutyActivityTypeIcon from '../../components/DutyActivityTypeIcon.vue';
import DutyActivityJson from '../../components/DutyActivityJson.vue';

export default {
  name: 'DutyActivityTitle_Default',
  mixins: [commonMixin],

  props: {
    duty: Object,
    dutyActivity: Object,
    config: Object,
    showAllTracksBtn: { type: Boolean, default: false },
    hasTrueChildren: { type: Boolean, default: false },
  },
  components: {
    DutyActivityJson,
    DutyActivityTypeIcon,
  },
  data() {
    return {
      selectAllLine: true,
    };
  },
  computed: {
    courseTitle() {
      let title = '';
      if (this.dutyActivity && this.hasTrueChildren) {
        if (this.dutyActivity.children && Array.isArray(this.dutyActivity.children)) {
          for (let i = 0; i < this.dutyActivity.children.length; i++) {
            if (this.dutyActivity.children[i].line && this.dutyActivity.children[i].course) {
              title = this.dutyActivity.children[i].line + '' + this.dutyActivity.children[i].course.padStart(2, '0');
              break;
            }
          }
        }
      }
      return title;
    },
    showTitleJsonHint() {
      return this.config.showTitleJsonHint;
    },
    showActivityTypeIcon() {
      return this.config.showActivityTypeIcon;
    },
  },
  methods: {
    onSelect() {
      // console.debug('selectAllLine', this.selectAllLine);
      this.selectAllLine = !this.selectAllLine;
      if (this.selectAllLine) {
        this.$emit('onSelectDutyActivity');
      } else {
        this.$emit('onSelectAllLine');
      }
    },
  },
};
</script>
